module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-12.a114202b.png";